export const AppColors = {
  // Primary colors
  primary: '#A3D6CC',
  primaryLight: '#B8E0D8',
  primaryDark: '#8BC4B8',
  primaryLighter: '#E8F5F3',
  
  // Secondary colors
  secondary: '#6C757D',
  
  // Accent colors
  accent: '#FF6B6B',
  
  // Box colors
  voiceBoxColor: '#A3D6CC', // Flutter版と同じミントグリーン
  thanksBoxColor: '#FFE4B5', // Flutter版と同じペールオレンジ
  themeBoxColor: '#FFB6C1', // Flutter版と同じライトピンク
  
  // Status colors
  success: '#28A745',
  warning: '#FFC107',
  error: '#DC3545',
  info: '#17A2B8',
  
  // Background colors
  background: '#F8F9FA',
  surface: '#FFFFFF',
  
  // Text colors
  textPrimary: '#212529',
  textSecondary: '#6C757D',
  textTertiary: '#ADB5BD',
  
  // Border colors
  border: '#DEE2E6',
  
  // Gradient colors
  gradientPrimary: 'linear-gradient(135deg, #A3D6CC 0%, #B8E0D8 100%)',
  gradientSecondary: 'linear-gradient(135deg, #6C757D 0%, #ADB5BD 100%)',
  
  // Utility methods
  withOpacity: (color: string, opacity: number) => `${color}${Math.round(opacity * 255).toString(16).padStart(2, '0')}`,
};